import { CONTENT_TYPES } from '@/util/access_visibility'

export const LIBRARY_EVENT_NAMES = {
    VIEW_MODE: {
        ALL: 'Viewed All Folders Page',
        ARCHIVED: 'Viewed Archived Folders Page',
        OWNED: 'Viewed My Folders Page',
        SHARED: 'Viewed Shared Folders Page',
    },
    FOLDER_ACTION: {
        CLICKED_EDIT_FOLDER: 'Clicked Edit Folder Button',
        CLICKED_DELETE_FOLDER: 'Clicked Delete Folder Button',
        CLICKED_SHARE_FOLDER: 'Clicked Share Folder',
        CLICKED_ARCHIVE_FOLDER: 'Clicked Archive Folder',
        CLICKED_UNARCHIVE_FOLDER: 'Clicked Unarchive Folder',
        CLICKED_SEND_SHARED_FOLDER_INVITATION: 'Clicked Send Shared Folder Invitation',
        ATTEMPTED_OPEN_ARCHIVE_FOLDER: 'Attempted Open Archive Folder',
        REMOVED_FOLDER_USER: 'Removed Folder User',
        CLICKED_ADD_FOLDER: 'Clicked Add Folder',
        OPENED_SHARE_FOLDER_MODAL: 'Opened Share Folder Modal',
        TRANSFERRED_FOLDER_OWNERSHIP: 'Transferred Folder Ownership',
    },
    SAVE_TO_LIBRARY: {
        GOAL: 'Clicked Save Goal to Library',
        STRATEGY: 'Clicked Save Strategy to Library',
        PRESENT_LEVELS: 'Clicked Save Present Levels to Library',
        COPIED_TO_ANOTHER_FOLDER: 'Copied Present Levels to Another Folder'
    },
    SHARE_STRATEGY: {
        CLICKED_CREATE_SHARE_LINK: 'Clicked Create Share Link',
        SHARED: 'Library Strategy Shared'
    },
    SHARE_GOAL: {
        CLICKED_CREATE_SHARE_LINK: 'Clicked Create Share Link',
        SHARED: 'Library Goal Shared',
        CREATED_SHARE_LINK: 'Created Share Link for Saved Goal'
    },
    COPIED_CONTENT_FOR_FOLDER: 'Copied Library Content For Student',
    COPIED_SHARE_LINK: 'Copied Share Link',
    REVEALED_CONTRIBUTOR_TOOLTIP: 'Revealed Contributor Tooltip',
    CLICKED_SAVED_THREADS: 'Clicked Saved Threads Link',
    ATTACHMENT: {
        OPENED_ADD_ATTACHMENT_MODAL: 'Opened Add Attachment Modal',
        CLICKED_ADD_ATTACHMENT: 'Clicked Add Attachment',
        OPENED_LIBRARY_ATTACHMENT: 'Opened Library Attachment',
        CLICKED_EDIT_ATTACHMENT: 'Clicked Edit Attachment',
        SUBMITTED_ATTACHMENT_EDIT: 'Submitted Attachment Edit',
        CLICKED_DELETE_ATTACHMENT: 'Clicked Delete Attachment'
    },
    FOLDER_COMMENT: {
        POSTED_FOLDER_COMMENT: 'Posted Folder Comment',
        DELETED_FOLDER_COMMENT: 'Deleted Folder Comment',
    }
}

// The Present Levels Wizard's save event still carries the deprecated present_level_uuid alongside plw_uuid
export function deprecatedPresentLevelsSaveEventData(contentType: string, contentUuid: string) {
  if (contentType !== CONTENT_TYPES.PRESENTLEVEL) {
    return {}
  }
  return { present_level_uuid: contentUuid }
}
